import createAction from './create-action';
import ApiService from '../../services/api-service';
import { Dispatch } from 'redux';
import { CancelToken } from 'axios';

/**
 * ACTION TYPES
 */
export const POINT_GET = 'point:get';

/**
 * THUNKS
 */

export const resetPoint = () => (dispatch: Dispatch) => dispatch(createAction(`${POINT_GET}:reset`));

export const getPoint = (university: string, pointId: string | number, cancelToken?: CancelToken) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(POINT_GET, ApiService.getPoint(university, pointId, undefined, cancelToken), {
      __PARSABLE__: true,
    })
  );
};
